import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlaylistAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"playlist_add"}/>
}
